<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div
      :disabled="disabled"
      :isLeftEnd="isLeftEnd"
      :isRightEnd="isRightEnd"
      :class="$style.container"
      :style="style.container"
    >
      <div
        :disabled="disabled"
        :isLeftEnd="isLeftEnd"
        :isRightEnd="isRightEnd"
        :class="$style.header"
        :style="style.header"
      >
        <slot
          :disabled="disabled"
          name="header"
        />
      </div>
      <div
        v-for="(row, index) in rows"
        :key="index"
        :disabled="disabled"
        :isLeftEnd="isLeftEnd"
        :isRightEnd="isRightEnd"
        :class="$style.row"
        :style="style.row"
      >
        <slot
          name="row"
          :disabled="disabled"
          :index="index"
          :isLastRow="index === rows.length - 1"
          :row="row"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { CssStyleProcessor } from '@js/vue-style-utils'

  export default {
    name: 'BaseTableColumn',
    inheritAttrs: false,
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      isLeftEnd: {
        type: Boolean,
        required: false,
        default: false,
      },
      isRightEnd: {
        type: Boolean,
        required: false,
        default: false,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
      rows: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        style: {
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
          },
          header: {
            width: '100%',
          },
          root: {},
          row: {
            width: '100%',
          },
        },
      };
    },
    created: function () {
      const proc = new CssStyleProcessor(
        '--v2-base-table-column',
        ['is-left-end', 'is-right-end'],
      );

      Object.assign(
        this.style.container,
        proc.getExtendedStyle(this.styleConfig.container, 'container'),
      );
      Object.assign(
        this.style.header,
        proc.getExtendedStyle(this.styleConfig.header, 'header'),
      );
      Object.assign(
        this.style.row,
        proc.getExtendedStyle(this.styleConfig.row, 'row'),
      );

      Object.assign(
        this.style.root,
        this.styleConfig.root,
      );
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--v2-base-table-column-container-background-color)
    border var(--v2-base-table-column-container-border)
    border-radius var(--v2-base-table-column-container-border-radius)
    border-width var(--v2-base-table-column-container-border-width)
    box-shadow var(--v2-base-table-column-container-box-shadow)
    &[disabled]
      background-color var(--v2-base-table-column-container-background-color-disabled)
      border var(--v2-base-table-column-container-border-disabled)
      border-radius var(--v2-base-table-column-container-border-radius-disabled)
      border-width var(--v2-base-table-column-container-border-width-disabled)
      box-shadow var(--v2-base-table-column-container-box-shadow-disabled)

  .header
    background-color var(--v2-base-table-column-header-background-color)
    border var(--v2-base-table-column-header-border)
    border-radius var(--v2-base-table-column-header-border-radius)
    border-width var(--v2-base-table-column-header-border-width)
    box-shadow var(--v2-base-table-column-header-box-shadow)
    color var(--v2-base-table-column-header-color)
    cursor var(--v2-base-table-column-header-cursor)
    font-family var(--v2-base-table-column-header-font-family)
    font-size var(--v2-base-table-column-header-font-size)
    font-weight var(--v2-base-table-column-header-font-weight)
    &[isLeftEnd]
      background-color var(--v2-base-table-column-header-background-color-is-left-end)
      border var(--v2-base-table-column-header-border-is-left-end)
      border-radius var(--v2-base-table-column-header-border-radius-is-left-end)
      border-width var(--v2-base-table-column-header-border-width-is-left-end)
      box-shadow var(--v2-base-table-column-header-box-shadow-is-left-end)
      color var(--v2-base-table-column-header-color-is-left-end)
      cursor var(--v2-base-table-column-header-cursor-is-left-end)
      font-family var(--v2-base-table-column-header-font-family-is-left-end)
      font-size var(--v2-base-table-column-header-font-size-is-left-end)
      font-weight var(--v2-base-table-column-header-font-weight-is-left-end)
    &[isRightEnd]
      background-color var(--v2-base-table-column-header-background-color-is-right-end)
      border var(--v2-base-table-column-header-border-is-right-end)
      border-radius var(--v2-base-table-column-header-border-radius-is-right-end)
      border-width var(--v2-base-table-column-header-border-width-is-right-end)
      box-shadow var(--v2-base-table-column-header-box-shadow-is-right-end)
      color var(--v2-base-table-column-header-color-is-right-end)
      cursor var(--v2-base-table-column-header-cursor-is-right-end)
      font-family var(--v2-base-table-column-header-font-family-is-right-end)
      font-size var(--v2-base-table-column-header-font-size-is-right-end)
      font-weight var(--v2-base-table-column-header-font-weight-is-right-end)
  &[disabled]
      background-color var(--v2-base-table-column-header-background-color-disabled)
      border var(--v2-base-table-column-header-border-disabled)
      border-radius var(--v2-base-table-column-header-border-radius-disabled)
      border-width var(--v2-base-table-column-header-border-width-disabled)
      box-shadow var(--v2-base-table-column-header-box-shadow-disabled)
      color var(--v2-base-table-column-header-color-disabled)
      cursor var(--v2-base-table-column-header-cursor-disabled)
      font-family var(--v2-base-table-column-header-font-family-disabled)
      font-size var(--v2-base-table-column-header-font-size-disabled)
      font-weight var(--v2-base-table-column-header-font-weight-disabled)

  .row
    background-color var(--v2-base-table-column-row-background-color)
    border var(--v2-base-table-column-row-border)
    border-radius var(--v2-base-table-column-row-border-radius)
    border-width var(--v2-base-table-column-row-border-width)
    box-shadow var(--v2-base-table-column-row-box-shadow)
    color var(--v2-base-table-column-row-color)
    cursor var(--v2-base-table-column-row-cursor)
    font-family var(--v2-base-table-column-row-font-family)
    font-size var(--v2-base-table-column-row-font-size)
    font-weight var(--v2-base-table-column-row-font-weight)
    &[isLeftEnd]
      background-color var(--v2-base-table-column-row-background-color-is-left-end)
      border var(--v2-base-table-column-row-border-is-left-end)
      border-radius var(--v2-base-table-column-row-border-radius-is-left-end)
      border-width var(--v2-base-table-column-row-border-width-is-left-end)
      box-shadow var(--v2-base-table-column-row-box-shadow-is-left-end)
      color var(--v2-base-table-column-row-color-is-left-end)
      cursor var(--v2-base-table-column-row-cursor-is-left-end)
      font-family var(--v2-base-table-column-row-font-family-is-left-end)
      font-size var(--v2-base-table-column-row-font-size-is-left-end)
      font-weight var(--v2-base-table-column-row-font-weight-is-left-end)
    &[isRightEnd]
      background-color var(--v2-base-table-column-row-background-color-is-right-end)
      border var(--v2-base-table-column-row-border-is-right-end)
      border-radius var(--v2-base-table-column-row-border-radius-is-right-end)
      border-width var(--v2-base-table-column-row-border-width-is-right-end)
      box-shadow var(--v2-base-table-column-row-box-shadow-is-right-end)
      color var(--v2-base-table-column-row-color-is-right-end)
      cursor var(--v2-base-table-column-row-cursor-is-right-end)
      font-family var(--v2-base-table-column-row-font-family-is-right-end)
      font-size var(--v2-base-table-column-row-font-size-is-right-end)
      font-weight var(--v2-base-table-column-row-font-weight-is-right-end)
    &[disabled]
      background-color var(--v2-base-table-column-row-background-color-disabled)
      border var(--v2-base-table-column-row-border-disabled)
      border-radius var(--v2-base-table-column-row-border-radius-disabled)
      border-width var(--v2-base-table-column-row-border-width-disabled)
      box-shadow var(--v2-base-table-column-row-box-shadow-disabled)
      color var(--v2-base-table-column-row-color-disabled)
      cursor var(--v2-base-table-column-row-cursor-disabled)
      font-family var(--v2-base-table-column-row-font-family-disabled)
      font-size var(--v2-base-table-column-row-font-size-disabled)
      font-weight var(--v2-base-table-column-row-font-weight-disabled)
</style>
